import orderBy from 'lodash.orderby';
import set from 'lodash.set';

export function isActiveCategory(category, pathname) {
  const {articles} = category;

  return articles.some(({href}) => pathname.includes(href));
}

const flatten = edges => edges.map(({node}) => node);

export const articleHref = ({slug, number}) => `/article/${number}-${slug}`;

export const categoryHref = category => {
  if (category.articles[0]) {
    return articleHref(category.articles[0]);
  }
  return '#';
};

export function buildTree(categoryEdges, articleEdges) {
  const categoryNodes = orderBy(flatten(categoryEdges), ['order']);
  const articleNodes = flatten(articleEdges);

  // initialize the tree
  const tree = categoryNodes.reduce((acc, category) => {
    const {name, id, slug, articleCount, description} = category;
    const node = {
      id,
      description,
      name,
      slug,
      articleCount,
      articles: [],
    };

    return set(acc, id, node);
  }, {});

  // populate the tree and return it
  return articleNodes.reduce(
    (acc, article) =>
      article.categories.reduce(
        (treeWithArticles, id) =>
          set(
            treeWithArticles,
            [id, 'articles', treeWithArticles[id].articles.length],
            {...article, parent: id, href: articleHref(article)}
          ),
        acc
      ),
    tree
  );
}



// WEBPACK FOOTER //
// ./src/lib/categories.js